import { IAR, IEN, ILocale } from './types';

const AR = 'ar' as IAR;
const EN = 'en' as IEN;

export const locales = {
  AR,
  EN,
};

export const rtlLocales: ILocale[] = [AR];

export const localesArr: ILocale[] = Object.values(locales);

export const actualDefaultLocale = locales.EN;
